module.exports = __webpack_public_path__ + "static/flinks4-2faf873aba95e5634a936df4518d687a.png";